import { FOLDER_PATH_SEPARATOR } from '../constants/folder';

/**
 * Extract the ids of all folders in a path
 *
 * @param {string} path - the path to a folder
 * @returns {string[]} the ids of the folders in the path
 */
export const getFolderIdsFromPath = path => {
  const trimmedPath = path && path[0] === FOLDER_PATH_SEPARATOR ? path.substring(1) : path;

  const folderIds = trimmedPath.split(FOLDER_PATH_SEPARATOR);

  return folderIds;
};

/**
 * Extract the id of a folder from its path
 *
 * @param {string} path - the path to a folder, including the folder
 * @returns {string} the id of the folder
 */
export const getFolderIdFromPath = path => {
  const folderIds = getFolderIdsFromPath(path);

  return folderIds.length ? folderIds[folderIds.length - 1] : null;
};
